// Moblyze staff ("super users"): a Recruiter with the portal's isOwner flag.
// The same rule the AI worker's admin routes (isMyaAdmin) and the client-mail
// worker's service-account routes enforce server-side; checks in the portal
// are a second layer so nobody else sees staff-only UI or fires its fetches.
export function isMoblyzeAdmin(user) {
  return user?.role === "Recruiter" && user?.isOwner === true;
}
